import { render } from "./MenuAbaixo.vue?vue&type=template&id=0536cf5c&scoped=true"
import script from "./MenuAbaixo.vue?vue&type=script&lang=js"
export * from "./MenuAbaixo.vue?vue&type=script&lang=js"

import "./MenuAbaixo.vue?vue&type=style&index=0&id=0536cf5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0536cf5c"]])

export default __exports__